import React, { createContext, useState } from "react";
export const OrderContext = createContext([]);

export const OrderProvider = (props) => {
    const [orderDetails, setOrderDetails] = useState({
        company:'',
        services:[]
      })
      const [companyAddress, setCompanyAddress] = useState([])
  return (
    <OrderContext.Provider value={{ details: [orderDetails, setOrderDetails], address: [companyAddress, setCompanyAddress] }}>
      {props?.children}
    </OrderContext.Provider>
  );
};
